import React from 'react';
import { useTranslation } from 'react-i18next';
import { useEffectOnce } from 'react-use';
import brokenLinkIcon from '@/enterprise/assets/broken-link.svg?url';
import { useReporting } from '@/reporting';
import { ButtonLink } from '@/shared/components/ButtonLink';
import { asEnterpriseLink } from '@/utils/experienceLinkHelper';
import { ErrorPageTemplate } from './ErrorPageTemplate';

interface BuyerNavigationLayoutErrorProps {
  marketId: string;
  takerId: number;
  makerOrganizationUuid: string;
}

export const BuyerNavigationLayoutError: React.FC<BuyerNavigationLayoutErrorProps> = ({
  marketId,
  takerId,
  makerOrganizationUuid,
}) => {
  const { trackEnterpriseEvent } = useReporting();
  const { t } = useTranslation();

  useEffectOnce(() => {
    trackEnterpriseEvent('error::invalid-buyer-navigation::shown', { marketId, takerId, makerOrganizationUuid });
  });

  return (
    <ErrorPageTemplate
      title={t('draftOffer.errors.invalid.title')}
      cardSlot={
        <div>
          <div className="flex flex-col">
            <div className="flex flex-col items-center gap-4 sm:flex-row">
              <img src={brokenLinkIcon} alt="invalid-buyer-navigation-error" className="h-20 w-20" />
              <p>{t('core.noAccessMessage')}</p>
            </div>
          </div>
          <div className="mt-6 flex justify-center sm:mt-4 sm:justify-end">
            <ButtonLink className="w-fit" to={asEnterpriseLink('markets')} variant="primary">
              {t('draftOffer.errors.action')}
            </ButtonLink>
          </div>
        </div>
      }
    />
  );
};
